<template>
    <a-card class="UserManage">
        <a-form-model layout="inline">
            <a-form-model-item label="输入搜索">
                <a-input placeholder="请输入手机号或用户ID" allow-clear :maxLength="20" v-model="searchForm.param"/>
            </a-form-model-item>
            <a-form-model-item label="账号状态">
                <a-select class="serach-item" allowClear v-model="searchForm.isActivate" @keyup.enter="getList(1)" placeholder="请选择">
                    <a-select-option :value="false">未激活</a-select-option>
                    <a-select-option :value="true">已激活</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="账号来源">
                <a-select class="serach-item" allowClear v-model="searchForm.origin" @keyup.enter="getList(1)" placeholder="请选择">
                    <a-select-option value="0">其他</a-select-option>
                    <a-select-option value="1">小商店</a-select-option>
                    <a-select-option value="2">公众号绑定</a-select-option>
                    <a-select-option value="3">兑换码</a-select-option>
                    <a-select-option value="4">快速测评</a-select-option>
                    <a-select-option value="5">教材账号</a-select-option>
                    <a-select-option value="6">大脑课堂</a-select-option>
                    <a-select-option value="7">免费测评</a-select-option>
                    <a-select-option value="8">系列码</a-select-option>
                    <a-select-option value="9">免费领课</a-select-option>
                    <a-select-option value="10">脑智家游</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item style="margin-left: 35px;">
                <a-button type="primary" @click="getList(1)">查询</a-button>
                <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="table">
            <a-table style="min-width: 800px;"
                :columns="columns"
                row-key="id"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <div slot="mobile" slot-scope="text, record" class="_flex">
                    {{text.mobile}}
                    <div :class="'source' + text.origin" class="source">{{stage[text.origin]}}</div>
                </div>
                <div slot="orderNum" slot-scope="text, record">
                    <span>{{text.orderNum || '--'}}</span>
                </div>
                <div slot="price" slot-scope="text, record">
                    <span v-if="text.price">￥{{text.price}}</span>
                    <span v-else>--</span>
                </div>
                <div slot="lastOpenCourseTime" slot-scope="text, record">
                    {{text.lastOpenCourseTime || '--'}}
                </div>
                <div slot="isActivate" slot-scope="text, record" class="_flex">
                    <div class="dian" :class="'dian' + text.isActivate"></div>
                    <span :class="text.isActivate ? 'green' : 'red' ">{{text.isActivate ? '已激活' : '未激活' }}</span>
                </div>
                <div slot="action" slot-scope="text, record">
                    <a @click="view(text)" v-permission="`/operate/UserManage/UserDetail`">查看</a>
                </div>
            </a-table>
        </div>
    </a-card>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus"
import {tableRelevant} from "@/pages/projectImpl/js/utils";

const columns = [
    { title: '用户ID', key: "1", dataIndex: 'accountId',},
    { title: '手机号', key: "2", scopedSlots: {customRender: 'mobile'}},
    { title: '订单数量', key: "3", scopedSlots: {customRender: 'orderNum'}},
    { title: '消费金额', key: "4", scopedSlots: {customRender: 'price'}},
    { title: '上次开课时间', key: "5", scopedSlots: {customRender: 'lastOpenCourseTime'}},
    { title: '账号状态', key: "6", scopedSlots: {customRender: 'isActivate'}},
    { title: '操作', key: "7", scopedSlots: {customRender: 'action'}}
]
export default {
    name:'UserManage',
    data () {
        return {
            searchForm:{
                param:undefined,
                isActivate:undefined,
                origin:undefined,
            },
            columns,
            tableRelevant: tableRelevant.call(this,this.getList),
            stage: ['其他',"小商店", "公众号绑定", "兑换码", "快速测评", "教材账号","大脑课堂","免费测评",'系列码','免费领课','脑智家游'],
        }
    },
    created () {

    },
    mounted() {
        this.getList(1)
        $Bus.$emit("pageHeaderTitle", "用户列表");
    },
    methods: {
        getList(pageIndex){
            let params = {
                ...this.searchForm,
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
            }
            this.tableRelevant.tableLoading = true
            this.$http.operate.GetUserPageList(params)
            .then(res => {
                this.tableRelevant.tableLoading = false
                    this.tableRelevant.tableDataSource = res.data.items
                    this.tableRelevant.tablePagination.total = res.data.totalCount;
                    this.tableRelevant.tablePagination.current = res.data.pageIndex;
              
            })
            .catch(err=>{
                this.tableRelevant.tableLoading = false
            })
        },
        resetSearch(){
            this.searchForm = {
                name:undefined,
                status:undefined,
                source:undefined,
            }
            this.getList(1)
        },
        view(text){
            this.$router.push({
                path:'/operate/UserManage/UserDetail',
                query:{
                    accountId:text.accountId
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
._flex{
    display:flex;
    align-items:center;
}
.source{
    margin-left:10px;
    padding:0 10px;
    font-size:14px;
    border-radius: 5px;
}
.source0{
    color: #1890ff;
    background: #e6f7ff;
    border-color: #91d5ff;
}
.source1{
    border:1px solid #E76192;
    color:#E76192;
    background:#FDF2F5;
}
.source2{
    border:1px solid #E4413E;
    color:#E4413E;
    background:#FCF1EF;
}
.source3{
    border:1px solid #E96D41;
    color:#E96D41;
    background:#FDF2E9;
}
.source4{
    border:1px solid #85C957;
    color:#85C957;
    background:#F7FEEF;
}
.source5{
    border:1px solid #63C6C7;
    color:#63C6C7;
    background:#ECFEFA;
}
.source6{
    border:1px solid #d3adf7;
    color: #722ed1;
    background: #f9f0ff;
}
.source7{
    border:1px solid #87e8de;
    color: #13c2c2;
    background: #e6fffb;
}
.source8{
    border:1px solid #87e8de;
    color: #13c2c2;
    background: #e6fffb;
}
.source9{
    border:1px solid #E96D41;
    color: #E96D41;
    background: #FDF2E9;
}
.source10{
    border:1px solid #E96D41;
    color: #E96D41;
    background: #FDF2E9;
}
.dian{
    width:5px;
    height:5px;
    border-radius: 5px;
    margin-right:5px;
}
.diantrue{
    background:#54BB75;
}
.dianfalse{
    background:#f00;
}
.red{
    color:#f00;
}
.green{
    color:#54BB75;
}
</style>
